import { render, staticRenderFns } from "./StatHelpdesk.vue?vue&type=template&id=07fbc461&lang=pug&"
import script from "./StatHelpdesk.vue?vue&type=script&lang=js&"
export * from "./StatHelpdesk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports